import { useMemo, useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import { createColumns } from "../../../helpers";
import { DATATABLE_CUSTOM_STYLES } from "../../../constants/datatableStyles";
import CustomPagination from "../../../Components/CustomPagination";
import PageTitle from "../../../Components/UI/PageTitle";
import RowLoader from "../../../Components/UI/RowLoader";
import { getPartnersToSendMessages } from "../../../apis";

const PartnersListToSendNewMessage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [pagination, setPagination] = useState({});
  const [currentPage, setCurrentPage] = useState(
    parseInt(new URLSearchParams(location.search).get("page"), 10) || 1
  );
  const [searchTerm, setSearchTerm] = useState(
    new URLSearchParams(location.search).get("search") || ""
  );

  useEffect(() => {
    setIsLoading(true);
    getPartnersToSendMessages(currentPage, searchTerm)
      .then((response) => {
        setData(response.data.data);
        setPagination({
          current_page: response.data.current_page,
          last_page: response.data.last_page,
        });
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [currentPage, searchTerm]);

  useEffect(() => {
    const params = new URLSearchParams();
    params.set("page", currentPage);
    if (searchTerm) params.set("search", searchTerm);
    navigate({ search: params.toString() });
  }, [currentPage, navigate, searchTerm]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const filterAndSortData = () => {
    return data;
  };

  const customColumns = [
    {
      name: "Action",
      selector: (row) => row.name + " - custom",
      ui: (row) =>
        row.isActive === "Active" ? (
          <Link
            className="tw-text-primary tw-underline"
            to={`/send-new-message-to-partner/${row.id}`}
          >
            Send Message
          </Link>
        ) : (
          "-"
        ),
    },
  ];

  const hiddenColumns = ["id"]; // Add column keys you want to hide

  const columns = useMemo(() => {
    return createColumns(data, customColumns, hiddenColumns, true).map(
      (col) => ({
        ...col,

        sortable: false,
        width: col.name === "Num" ? "60px" : "1fr",
      })
    );
  }, [data]);

  const handleFilter = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page on search change
  };

  return (
    <>
      <PageTitle title="Partners" />
      <div className="bg-white flex flex-col mt-4">
        <div className="bg-white shadow-lg rounded-lg flex flex-col p-2 gap-2 mb-5">
          <div className="relative">
            <div className="tw-mb-2">
              <input
                type="text"
                onChange={handleFilter}
                value={searchTerm}
                className="border border-blue-300 rounded-lg p-2 col-md-12 tw-mb-2"
                placeholder="Search by name"
              />
            </div>
          </div>
          <DataTable
            columns={columns}
            data={filterAndSortData()}
            customStyles={DATATABLE_CUSTOM_STYLES}
            progressPending={isLoading}
            sortServer
            progressComponent={<RowLoader />}
          />

          <div className="flex justify-center mt-4">
            <CustomPagination
              totalPages={pagination?.last_page}
              currentPage={pagination?.current_page || 1}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PartnersListToSendNewMessage;
